module.exports = __webpack_public_path__ + "img/dynamic-8.2b8b881c.png";